<div class="input-group" [class._noUnit]="!unit">
    <input #input="ngModel"
           (ngModelChange)="onChange($event)"
           [ngModel]="data"
           [kiwiMax]="max"
           [kiwiMin]="min"
           [min]="min"
           [max]="max"
           type="number"
           [name]="name"
           [disabled]="disabled"
           [step]="step"/>
    <span class="input-group-label" *ngIf="!!unit" [i18nKey]="unit"></span>
</div>
